import firebase, { db } from '@/plugins/firebase'

export class Firmware {
  constructor (
    readonly fileName: string,
    readonly fileSize: number,
    readonly modelNo: string,
    readonly name: string,
    readonly bufferSize: number,
    readonly version: string,
    readonly description: string,
    readonly updatedAt?: Date,
    readonly createdAt?: Date
  ) {

  }
}

export const converter: firebase.firestore.FirestoreDataConverter<Firmware> = {
  toFirestore (model: Partial<Firmware>, setOptions?: firebase.firestore.SetOptions) {
    if (setOptions?.merge) {
      return Object.assign(model, { updatedAt: firebase.firestore.FieldValue.serverTimestamp() })
    }

    return {
      fileName: model.fileName,
      fileSize: model.fileSize,
      modelNo: model.modelNo,
      name: model.name,
      bufferSize: model.bufferSize,
      version: model.version,
      description: model.description,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    }
  },
  fromFirestore (snapshot: firebase.firestore.QueryDocumentSnapshot) {
    const data = snapshot.data()

    return new Firmware(
      data.fileName,
      data.fileSize,
      data.modelNo,
      data.name,
      data.bufferSize,
      data.version,
      data.description || '',
      (data.updatedAt as firebase.firestore.Timestamp)?.toDate(),
      (data.createdAt as firebase.firestore.Timestamp)?.toDate()
    )
  }
}
export default db.collection('firmwares').withConverter(converter)
